export default "__VITE_ASSET__8ea3aed9__"